// by using universal-cookie, you can expect that this code will only work
// client-side. to make it work server-side, have your component pass the
// cookies object provided to it by the `withCookies` HOC.
import Cookies from "universal-cookie";
import ActionLogger from "action-logger";
import GlobalStore from "helpers/react-redux-initializer";
import AuthActions from "actions/auth-actions";
import { getParameterByName, authorizationRequiredPaths } from "./authorization";
import { personalize } from "./personalization";
import { isStorefrontNext } from "helpers/environment-helpers";
import { HEAP_AUTH_TRIGGER_TYPES } from "helpers/heap-helpers";
import { getQueryParam } from "../helpers/location-helpers";
import { onDocumentReady } from "../helpers/document-helpers";

const RTR = window.RTR || {};
const cookies = new Cookies();

function logPageLoad() {
  const options = {
    event: "page_load",
    object_type: "top_nav",
    context: window.location.href,
    referrer: ActionLogger.getReferrer(),
  };

  ActionLogger.logAction(options);
}

function isLightRegAuthRequired() {
  const requireAuthParam = getParameterByName("require_auth");
  if (requireAuthParam !== "") {
    const pathsMessages = authorizationRequiredPaths();
    const message = pathsMessages[requireAuthParam];
    displayLightReg(false, requireAuthParam, message, HEAP_AUTH_TRIGGER_TYPES.MIDDLEWARE_AUTH_PROMPT);
  }
}

function setSEMCookie() {
  const campaign = getQueryParam("campaign");
  if (campaign?.toLowerCase().match(/ppc/) && !campaign.toLowerCase().match(/brand/)) {
    cookies.set("paid", 1, { path: "/", expires: 30 });
  }
}

onDocumentReady(function () {
  if (!isStorefrontNext()) {
    RTR.UX.fireWithUserData(logPageLoad);

    // don't know if we need personalize() in SF Ruby but def don't need it in SF Next.
    // `userDataReady` is not ready at this point in SF Next
    personalize();

    // do we need anything below?
  }

  isLightRegAuthRequired();
  setSEMCookie();
});

function displayLightReg(callback, source, subtitle, heapTriggeredBy, view, href) {
  if (isStorefrontNext()) {
    // dispatch DOM event
    window.dispatchEvent(
      new CustomEvent("siteHeaderRegModalEvent", {
        followQueryParams: !!callback,
        source,
        subtitle,
        heapTriggeredBy,
        view,
        href,
      })
    );
  } else {
    GlobalStore.store.dispatch(
      AuthActions.showAuthModal({ callback, source, subtitle, view, triggeredBy: heapTriggeredBy })
    );
  }
}
